import { render, staticRenderFns } from "./CertificatePreview.vue?vue&type=template&id=9047f25e&scoped=true&"
import script from "./CertificatePreview.vue?vue&type=script&lang=js&"
export * from "./CertificatePreview.vue?vue&type=script&lang=js&"
import style0 from "./CertificatePreview.vue?vue&type=style&index=0&id=9047f25e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9047f25e",
  null
  
)

export default component.exports